<template>
  <div>
    <div class="head-box">
      <h4>
        功能插件
      </h4>
      <div class="c-flex">
        <el-select
          style="margin-right: 10px"
          v-model="searchType"
          placeholder="筛选脚本类型"
          clearable
          @change="
            fpi.page = 1;
            getData();
          "
        >
          <el-option
            v-for="(item, index) in options.groovyScriptType"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-input
          placeholder="请输入名称"
          v-model="searchValue"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click.native="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
        <el-button type="primary" class="m-l-10" @click.native="doNew">新建功能插件</el-button>
      </div>
    </div>
    <div class="content-box">
      <div class="content-table">
        <el-table
          ref="table"
          :data="fpi.data"
          empty-text="暂无数据"
          height="calc(100% - 50px)"
          highlight-current-row
        >
          <el-table-column prop="order" label="执行顺序" width="80px"></el-table-column>
          <el-table-column prop="name" label="名称" width="200px">
            <template slot-scope="scope">
              <el-button @click.native.prevent="handleRowClick(scope.row)" size="mini" type="text">
                {{ scope.row.name }}
              </el-button>
            </template>
          </el-table-column>
          <el-table-column
            prop="memo"
            label="描述"
            width="150px"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="type"
            label="脚本类型"
            :formatter="formatGroovyScriptType"
            width="150px"
          ></el-table-column>
          <el-table-column
            prop="workflowDefIdentity"
            label="关联工作流"
            :formatter="formatWorkflow"
            width="200px"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="workflowDefNodeId"
            label="关联工作流节点"
            :formatter="formatNode"
          ></el-table-column>
          <el-table-column
            prop="preAction"
            label="是否前置"
            :formatter="formatIs"
          ></el-table-column>
          <el-table-column prop="version" label="当前版本号"></el-table-column>
          <el-table-column prop="state" label="状态">
            <template slot-scope="scope">
              <el-tag :type="scope.row.state == 1 ? '' : 'warning'">
                {{ scope.row.state == 1 ? '已启用' : '已禁用' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column fixed="right" width="100px">
            <template slot-scope="scope">
              <el-dropdown>
                <el-button>
                  操作
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="doEdit(scope.row)">
                    编辑
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="scope.row.state == 0"
                    @click.native="doEnable(scope.row._id)"
                  >
                    启用
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="scope.row.state == 1"
                    @click.native="doDisable(scope.row._id)"
                  >
                    禁用
                  </el-dropdown-item>
                  <el-dropdown-item @click.native="doRemove(scope.row._id)">
                    删除
                  </el-dropdown-item>
                  <el-dropdown-item @click.native="openChangelog(scope.row)">
                    操作记录
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      :visible.sync="openDetail"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="1000px"
      destroy-on-close
    >
      <div slot="title" class="c-dialog-title">
        <div>功能插件</div>
        <i class="el-icon-full-screen" style="color:#909399" @click="fullscreen = !fullscreen"></i>
      </div>
      <el-form
        :model="formData"
        ref="formData"
        :rules="rules"
        label-width="110px"
        label-position="left"
      >
        <el-form-item label="执行顺序">
          <el-input-number
            v-model="formData.order"
            :controls="false"
            :precision="0"
            placeholder="请输入数字"
          ></el-input-number>
        </el-form-item>
        <el-form-item
          label="名称"
          prop="name"
          :rules="{ required: true, trigger: 'blur', message: '请输入名称' }"
        >
          <el-input v-model="formData.name"></el-input>
        </el-form-item>
        <el-form-item label="描述">
          <el-input type="textarea" :rows="1" v-model="formData.memo"></el-input>
        </el-form-item>
        <el-form-item
          label="内容"
          prop="scriptContent"
          :rules="{ required: true, trigger: 'blur', message: '请输入内容' }"
        >
          <codemirror :formData="formData" :preset="1" fieldName="scriptContent"></codemirror>
        </el-form-item>
        <el-form-item
          label="脚本类型"
          prop="type"
          :rules="{ required: true, trigger: 'change', message: '请选择脚本类型' }"
        >
          <el-select v-model="formData.type" clearable>
            <el-option
              v-for="item in options.groovyScriptType"
              :key="item.value"
              :label="item.label"
              :value="Number(item.value)"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="关联工作流">
          <el-select
            v-model="formData.workflowDefIdentity"
            clearable
            filterable
            @change="getWorkflowNode"
          >
            <el-option
              v-for="item in options.workflow"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="关联工作流节点">
          <el-select
            v-model="formData.workflowDefNodeId"
            no-data-text="请先关联工作流"
            clearable
            @change="$forceUpdate()"
            filterable
          >
            <el-option
              v-for="item in options.workflowNode"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否前置">
          <el-radio-group v-model="formData.preAction">
            <el-radio v-for="(item, i) in options.is" :key="i" :label="Number(item.value)">
              {{ item.label }}
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="更改注释"
          prop="annotate"
          :rules="{ required: true, trigger: 'blur', message: '更改注释不能为空' }"
        >
          <el-input type="textarea" :rows="2" v-model="formData.annotate"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="doSave">确 定</el-button>
        <el-button @click="doInit">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="操作记录"
      :visible.sync="openHistory"
      width="900px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="box-center-content" :infinite-scroll-immediate="true">
        <template v-if="historyFpi.data.length">
          <el-table
            :data="historyFpi.data"
            style="width: 100%"
            height="400px"
            ref="groovyScriptTable"
            @selection-change="handleSelectionChange"
            @select="currentSelection"
            @select-all="
              $refs.groovyScriptTable.clearSelection();
              selectedList = [];
            "
          >
            <el-table-column type="selection" width="55" fixed></el-table-column>
            <el-table-column prop="version" label="版本号" width="60" fixed></el-table-column>
            <el-table-column prop="updateTime" label="提交时间" width="160"></el-table-column>
            <el-table-column prop="updateUserName" label="提交人" width="160"></el-table-column>
            <el-table-column prop="annotate" label="更改注释"></el-table-column>
            <el-table-column fixed="right" label="操作" width="120">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="small"
                  @click.native.prevent="contrastPresent(scope.row)"
                >
                  与当前版本对比
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="c-flex c-flex-end">
            <el-button size="small" class="c-m-t-10" @click.native.prevent="checkContrast">
              将选择的版本对比
            </el-button>
          </div>
          <el-pagination
            class="pagination"
            @size-change="pageSizeChangeLog"
            @current-change="pageChangeLog"
            :current-page="historyFpi.page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="historyFpi.rows"
            layout="total, sizes, prev, pager, next, jumper"
            :total="historyFpi.total"
          ></el-pagination>
          <!-- </div> -->
        </template>
        <div class="activity-card" v-else><div class="activity-card-header">暂无操作记录</div></div>
      </div>
    </el-dialog>
    <codeDiff
      v-if="openContrast"
      :oldStr="codeDiffData.oldVal"
      :newStr="codeDiffData.newVa"
      :leftVersion="codeDiffData.leftVersion"
      :rightVersion="codeDiffData.rightVersion"
    ></codeDiff>
  </div>
</template>
<script>
import { mapMutations } from 'vuex';
export default {
  activated() {
    window.$this = this;
  },
  name: 'GroovyScript',
  components: {
    codeDiff: () => import('../components/codeDiff'),
    codemirror: () => import('../components/codemirror')
  },
  data() {
    window.$this = this;
    let that = this;
    return {
      tenantId: '',
      searchValue: '',
      searchType: '',
      fpi: {},
      formData: { exts: {} },
      openDetail: false,
      rules: this.$util.rules,
      options: {
        codecfg_is: { codeId: 'IS' },
        codecfg_groovyScriptType: { codeId: 'groovyScriptType' }
      },
      //地址级联-懒加载
      area: {
        props: {
          checkStrictly: true,
          lazy: true,
          async lazyLoad(node, resolve) {
            const { level } = node;
            let nodes = [];
            if (level == '0') {
              nodes = await that.$util.getProvince();
            } else if (level == '1') {
              node.children = [];
              let id = node.data.code;
              nodes = await that.$util.getCity(id);
            } else if (level == '2') {
              node.children = [];
              let id = node.data.code;
              nodes = await that.$util.getDistrict(id);
            }
            // 通过调用resolve将子节点数据返回，通知组件数据加载完成
            resolve(nodes);
          }
        }
      },
      openHistory: false, // 操作记录弹窗
      // 操作记录列表
      historyFpi: {
        page: 1,
        rows: 20,
        data: [],
        busy: false
      },
      codeDiffList: [], //脚本操作记录选中的值
      openContrast: false, //打开对比
      //将要对比的代码值
      codeDiffData: {
        oldVal: '',
        newVa: '',
        leftVersion: null,
        rightVersion: null,
        currentData: null //当前版本最新代码
      },
      fullscreen: false
    };
  },
  mounted() {
    this.tenantId = JSON.parse(sessionStorage['entity']).tenantId;
    this.doInit();
    this.osg.codeoption(() => {
      this.getWorkflow();
    });
  },
  methods: {
    ...mapMutations(['SetCachedViews']),
    formatIs(row, column, cellValue) {
      if (cellValue == '1') return '是';
      else return '否';
    },
    formatGroovyScriptType(row, column, cellValue) {
      return this.osg.codelabel('groovyScriptType', cellValue);
    },
    formatWorkflow(row, column, cellValue) {
      return this.osg.codelabel('workflow', cellValue);
    },
    formatNode(row, column, cellValue) {
      return this.osg.codelabel('nodes', cellValue);
    },
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
      this.getData();
    },
    pageChange(currentPage) {
      this.fpi.page = currentPage;
      this.getData();
    },
    pageSizeChangeLog(pageSize) {
      this.historyFpi.rows = pageSize;
      this.getChangelog();
    },
    pageChangeLog(currentPage) {
      this.historyFpi.page = currentPage;
      this.getChangelog();
    },
    doInit() {
      this.openDetail = false;
      this.formData = {};
    },
    getData() {
      let params = {
        page: this.fpi.page || 1,
        rows: this.fpi.rows || 20,
        'regex:name|string#and': this.searchValue,
        'regex:scriptContent|string#and': this.searchValue,
        'is:type|integer#and': this.searchType,
        'in:state|array-integer#and': '0,1',
        sortField: 'workflowDefNodeId,order',
        sortOrder: 'asc'
      };
      this.osg.setFpi(params);
      this.osg.ajax('groovyScript/query.do', params, res => {
        this.fpi = res;
        this.$nextTick(() => {
          this.$refs.table && this.$refs.table.doLayout();
          this.$forceUpdate();
        });
      });
    },
    //监听操作记录勾选事件
    handleSelectionChange(list) {
      this.codeDiffList = list;
    },
    //合同列表勾选当前行
    currentSelection(rows) {
      if (rows.length > 2) this.$refs.groovyScriptTable.toggleRowSelection(rows.shift(), false); //2个选
    },
    doNew() {
      this.doInit();
      this.openDetail = true;
    },
    doEdit(row) {
      this.formData = row;
      // this.formData.exts = this.formData.exts || {};
      this.getWorkflowNode(row.workflowDefIdentity);
      this.openDetail = true;
    },
    doSave() {
      var params = this.formData;
      params.tenanId = this.tenantId;
      if (this.osg.validate()) {
        this.osg.ajax('groovyScript/upsert.do', this.formData, res => {
          this.osg.toast('保存成功');
          this.doInit();
          this.getData();
        });
      }
    },
    doEnable(id) {
      this.osg.ajax(`groovyScript/enable/${id}.do`, null, res => {
        this.osg.toast('启用成功');
        this.getData();
      });
    },
    doDisable(id) {
      this.osg.ajax(`groovyScript/disable/${id}.do`, null, res => {
        this.osg.toast('禁用成功');
        this.getData();
      });
    },
    doRemove(id) {
      this.osg.confirm('是否确认删除？', () => {
        this.osg.ajax(`groovyScript/remove/${id}.do`, null, res => {
          this.osg.toast('删除成功');
          this.getData();
        });
      });
    },
    //打开操作记录
    openChangelog(row) {
      //最新的脚本存储
      this.codeDiffData.currentData = this.$util.deepCopy(row);
      this.openHistory = true;
      this.getChangelog();
    },
    //获取脚本记录
    getChangelog(callback) {
      this.osg.ajax(
        'groovyScriptHis/query.do',
        {
          scriptId: this.codeDiffData.currentData._id,
          sortField: 'version',
          sortOrder: 'desc',
          page: this.historyFpi.page || 1,
          rows: this.historyFpi.rows || 20
        },
        res => {
          if (res) {
            this.historyFpi = res;
            console.log(this.historyFpi);
            this.$nextTick(() => {
              this.$refs.groovyScriptTable && this.$refs.groovyScriptTable.doLayout();
              this.$forceUpdate();
              if (callback) callback(res);
            });
          }
        },
        { noload: true }
      );
    },
    getWorkflow() {
      this.osg.ajax(
        'workflowDef/query.do',
        {
          _all: '1',
          'in:state|array-integer#and': '0,1'
        },
        res => {
          //查询所有工作流(列表返显和编辑弹窗下拉用)
          res.data.map(item => {
            item.label = item.title;
            item.value = item.identity || item._id;
          });
          this.options.workflow = res.data;
          //查询所有节点(列表返显用)
          let nodes = [];
          for (let workflow of res.data) {
            if (!workflow.def.nodes) break;
            for (let node of workflow.def.nodes) {
              nodes.push({
                label: node.name,
                value: node.nodeId
              });
            }
          }
          this.options.nodes = nodes;
          //查询列表数据
          this.osg.getFpi();
          this.getData();
        }
      );
    },
    getWorkflowNode(workflowDefIdentity) {
      if (this.openDetail) this.formData.workflowDefNodeId = ''; //点击编辑按钮时不清空
      this.osg.ajax(
        'workflowDef/query.do',
        {
          'is:identity|string#and': workflowDefIdentity
        },
        res => {
          let nodes = res.data[0].def.nodes;
          nodes.map(item => {
            item.label = item.name;
            item.value = item.nodeId;
          });
          this.options.workflowNode = nodes;
          this.$forceUpdate();
        }
      );
    },
    //与当前版本对比
    contrastPresent(row) {
      if (!this.codeDiffData.currentData.scriptContent || !this.codeDiffData.currentData.version) {
        this.osg.toast('最新脚本有误！', 'error');
        return;
      }
      this.openContrast = false;
      this.$nextTick(() => {
        this.codeDiffData.oldVal = row.scriptContent;
        this.codeDiffData.newVa = this.codeDiffData.currentData.scriptContent;
        this.codeDiffData.leftVersion = row.version;
        this.codeDiffData.rightVersion = this.codeDiffData.currentData.version;
        this.openContrast = true;
      });
    },
    //勾选对比
    checkContrast() {
      if (this.codeDiffList.length !== 2) {
        this.osg.toast('请选择两项！', 'warning');
        return;
      }
      this.openContrast = false;
      this.$nextTick(() => {
        this.codeDiffData.oldVal = this.codeDiffList[0].scriptContent;
        this.codeDiffData.newVa = this.codeDiffList[1].scriptContent;
        this.codeDiffData.leftVersion = this.codeDiffList[0].version;
        this.codeDiffData.rightVersion = this.codeDiffList[1].version;
        this.openContrast = true;
      });
    },
    handleRowClick(row) {
      this.$router.push({
        path: `/GroovyScriptParam/${row.identity}/${row.name}`
      });
      this.SetCachedViews({
        params: row.name,
        action: `/GroovyScriptParam/${row.identity}/${row.name}`
      });
    }
  }
};
</script>
<style scoped>
.el-radio {
  display: inline !important;
}
</style>
